module.exports = __webpack_public_path__ + "static/media/24.5ea0ba9e.svg";